import React, { useState, useContext, FormEvent } from "react";
import GOFloatingbox from "../../common/GOFloatingbox";
import { useTranslation } from "react-i18next";
import GOButton from "../../common/GOButton";
import GODate from "../../common/GODate";
import GOInput from "../../common/GOInput";
import { Context } from "../../../stores";
import dayjs from "dayjs";
import { NetLessonAddManually } from "../../../actions";
import GODropbox from "../../common/GODropbox";
import {
  UFloatingContainer,
  UFloatingBoxHeader,
  UFloatingBoxFooter,
  UFloatingBoxBody
} from "../../../GlobalUtilityStyles";

interface LessonAddManuallyProps {
  onClickExit?: any;
  update?: any;
  now: any;
  lessonProList?: any;
  onChange?: any;
  value?: any;
  selectedLessonTime?: any;
}

//Comments: 레슨 임시
const LessonAddManually = (props: LessonAddManuallyProps) => {
  const { t } = useTranslation();

  console.log("props.selectedLessonTime", props.selectedLessonTime);

  const selectedLessonTime = props.selectedLessonTime
    ? props.selectedLessonTime
    : new Date();

  console.log(new Date());

  const [data, setData] = useState<any>({
    employeeID: props.now,
    startDate: selectedLessonTime,
    startTime: selectedLessonTime,
    endTime: dayjs(selectedLessonTime)
      .add(30, "minute")
      .toDate(),
    lessonInterval: 30,
    memo: null
  });

  const Store = useContext(Context);
  const sending = Store.sending;

  const handleSubmit = (e: FormEvent<EventTarget>) => {
    console.log(props.now);
    console.log(data.startDate, data.startDate.toUTCString());
    console.log(data.startTime, data.startTime.toUTCString());
    if (data.employeeID === undefined) alert(t("lesson.selectLessonPro"));
    else {
      Store.actions.setSending(true);
      NetLessonAddManually({
        ...data,
        startDateDayjs: dayjs(data.startDate).format("YYYY-MM-DDTHH:mm:ss"),
        endDateDayjs: dayjs(data.endDate).format("YYYY-MM-DDTHH:mm:ss")
      })
        .then((res: any) => {
          alert(t("lesson.generationComplete"));
          Store.actions.setSending(false);
          if (props.update) {
            props.update();
          }
          if (props.onClickExit) {
            props.onClickExit();
          }
          if (props.onChange) {
            props.onChange(data.employeeID);
          }
        })
        .catch(() => {
          Store.actions.setSending(false);
        });
    }
  };

  return (
    <>
      <GOFloatingbox width={500}>
        <UFloatingContainer>
          <UFloatingBoxHeader>
            <h1>{t("lesson.manuallyAdd")}</h1>
            <p
              style={{
                fontWeight: "bold",
                color: "#fa5252",
                marginTop: "10px"
              }}
            >
              {t("lesson.message1")}
            </p>
            <p style={{ fontWeight: "bold", color: "#fa5252" }}>
              {t("lesson.message2")}
            </p>
            <p style={{ fontWeight: "bold", color: "#fa5252" }}>
              {t("lesson.message3")}
            </p>
            <p style={{ fontWeight: "bold", color: "#fa5252" }}>
              {t("lesson.message4")}
            </p>
            <p style={{ fontWeight: "bold", color: "#fa5252" }}>
              {t("lesson.message5")}
            </p>
          </UFloatingBoxHeader>
          <UFloatingBoxBody>
            <div className="flex_box">
              <GODropbox
                label={t("lesson.proName")}
                data={props.lessonProList?.map((e: any) => {
                  return { value: e.id, body: e.name };
                })}
                value={data.employeeID}
                onChange={(e: any) =>
                  setData({ ...data, employeeID: parseInt(e.target.value) })
                }
                isDefault
                required
              />
              <GODate
                label={t("lesson.date")}
                selected={new Date(data.startDate)}
                onChange={(date: any) => {
                  setData({ ...data, startDate: date });
                }}
                required
              />
              <GODate
                label={t("lesson.startTime")}
                onChange={(d: any) => {
                  console.log("startTime", d);
                  setData({ ...data, startTime: d });
                }}
                time
                timeOnly
                placeholder={t("lesson.clickToSet")}
                dataFormat="aa h:mm"
                selected={data.startTime && new Date(data.startTime)}
              />
              <GODate
                label={t("lesson.endTime")}
                onChange={(d: any) => {
                  console.log("endTime", d);
                  setData({ ...data, endTime: d });
                }}
                time
                timeOnly
                placeholder={t("lesson.clickToSet")}
                dataFormat="aa h:mm"
                selected={data.endTime && new Date(data.endTime)}
              />
              <GODropbox
                label={t("lesson.lessonTime")}
                value={data.lessonInterval}
                onChange={(e: any) => {
                  console.log("lessonInterval", e.target.value);
                  setData({ ...data, lessonInterval: e.target.value });
                }}
                isDefault
                required
                data={[
                  { value: 10, body: t("common.10min") },
                  { value: 15, body: t("common.15min") },
                  { value: 20, body: t("common.20min") },
                  { value: 25, body: t("common.25min") },
                  { value: 30, body: t("common.30min") },
                  { value: 40, body: t("common.40min") },
                  { value: 50, body: t("common.50min") },
                  { value: 60, body: t("common.60min") }
                ]}
              />
              <GOInput
                label={t("common.memo")}
                value={data.memo}
                onChange={(e: any) =>
                  setData({ ...data, memo: e.target.value })
                }
                textarea
              />
            </div>
          </UFloatingBoxBody>
          <UFloatingBoxFooter>
            <GOButton
              buttontype="green"
              onClick={handleSubmit}
              body={t("common.add")}
              loading={sending}
              disabled={sending}
            />
            <GOButton
              body={t("common.no")}
              onClick={props.onClickExit}
              disabled={sending}
            />
          </UFloatingBoxFooter>
        </UFloatingContainer>
      </GOFloatingbox>
    </>
  );
};

export default LessonAddManually;
